import { useUiKitComponents } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router";

import { useClientContext } from "~/contexts/client-context";
import type { Pages } from "~/core";
import { Footer, FooterTranslationProvider } from "~/features/footer";
import { FooterV3 } from "~/features/footerV3/FooterV3";
import type { loader } from "~/root";
import { useAction } from "~/widgets/use-action";

export const MainFooter: FC = () => {
  const data = useRouteLoaderData<typeof loader>("root");
  const { t } = useTranslation("footer");

  const { featureFlags, language } = useClientContext();
  const { Link } = useUiKitComponents();
  const { callAction: onCallAction, isActionInactive } = useAction();

  const getUrl = (detailedPage: Pages): string => {
    if (!detailedPage?.slug) {
      return `/`;
    }

    const { segment, slug } = detailedPage;
    if (segment) {
      return `/${segment}/${slug}`;
    } else {
      return `/${slug}`;
    }
  };
  const footerData = data?.footer;
  const footerStaticTranslations = {
    info: {
      rights:
        data?.translations.static_translations?.footer?.[0]
          ?.widget_info_rights ?? t("widget.info.rights"),
      gamblingAddictive:
        data?.translations.static_translations?.footer?.[0]
          ?.widget_info_gamblingAddictive ??
        t("widget.info.gambling-addictive"),
      playResponsibly:
        data?.translations.static_translations?.footer?.[0]
          ?.widget_info_playResponsibly ?? t("widget.info.play-responsibly"),
      supportDescription:
        data?.translations.static_translations?.footer?.[0]
          ?.widget_info_supportDescription ??
        t("widget.info.support-description"),
      supportEmail:
        data?.translations.static_translations?.footer?.[0]
          ?.widget_info_supportEmail ?? "widget.info.support-email",
    },
  };

  return (
    <>
      {featureFlags.getItem("footerMenuConstructor").enabled && footerData ? (
        <FooterV3
          data={footerData}
          getUrl={getUrl}
          onCallAction={onCallAction}
          isControlInactive={isActionInactive}
          width="100%"
          maxWidth={1270}
          p={{ px: 15, py: 40 }}
        />
      ) : (
        <FooterTranslationProvider value={footerStaticTranslations}>
          <Footer
            renderLink={(url, content) => <Link href={url}>{content}</Link>}
            featureFlags={{
              isFooterNavigationLinkEnabled: featureFlags.getItem(
                "footerNavigationLinks",
              ).enabled,
            }}
            documents={data?.documents ?? []}
            language={language}
          />
        </FooterTranslationProvider>
      )}
    </>
  );
};
